export default __webpack_public_path__ + "static/img/footer_ico_no.9704537.png";